import React from 'react';
import PlanBox from './planBox/PlanBox';
import './PricingPlans.css';

import { CONTENT } from '../config/landingPageContent';

const PricingPlans = ({ variant = 'default' }) => {
  const content = CONTENT[variant] || CONTENT.default;
  const plans = [
    {
      planName: 'Monthly🌟',
      description: content.pricing.monthly.description,
      price: '47.5',
      duration: 'Per Month',
      billingFrequency: 'Billed Monthly',
      buttonText: 'Subscribe',
      onButtonClick: () => console.log('Subscribe to Monthly plan'),
      details: {
        title: content.pricing.monthly.title,
        items: [
          content.pricing.monthly.item,
          'Unlimited Live Coding',
          'Session Summary x 6',
          'Cancel Renewal Anytime'
        ]
      },
      isPopular: false
    },
    {
      planName: 'Pay-per-Use 🎓',
      description: 'Ideal for occasional use, pay only when you need it. Use it anytime',
      price: '11.9',
      duration: 'Per Use',
      billingFrequency: '',
      buttonText: 'Load',
      onButtonClick: () => console.log('Load Pay-per-Use plan'),
      details: {
        title: content.pricing.payPerUse.title,
        items: [
          content.pricing.payPerUse.item,
          'Session Summary x 1',
          'One-time Purchase',
          'Does not expire'
        ]
      },
      isPopular: false
    },
    {
      planName: 'Quarterly🚀',
      description: content.pricing.quarterly.description,
      price: '29.5',
      duration: 'Per month',
      billingFrequency: 'Billed Quarterly',
      buttonText: 'Subscribe',
      onButtonClick: () => console.log('Subscribe to Quarterly plan'),
      details: {
        title: content.pricing.quarterly.title,
        items: [
          content.pricing.quarterly.item,
          'Unlimited Live Coding',
          'Session Summary x 18',
          'Cancel Renewal Anytime'
        ]
      },
      isPopular: true
    }
  ];

  return (
    <div className="pricing-plans">
      {plans.map((plan, index) => (
        <PlanBox
          key={index}
          {...plan}
          onCancelClick={plan.buttonText === 'Subscribe' ? () => console.log(`Cancel ${plan.planName} plan`) : null}
          isRenewActive={false}
          isDisabled={false}
        />
      ))}
    </div>
  );
};

export default PricingPlans;